import { render, staticRenderFns } from "./CustomerServiceRatings.vue?vue&type=template&id=f8ef214e&scoped=true&class=customer-service-ratings&"
import script from "./CustomerServiceRatings.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceRatings.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceRatings.vue?vue&type=style&index=0&id=f8ef214e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ef214e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VDataTable,VDialog,VRow,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
